// services/api/bannerService.js
import https from "../../configs/axios.config";
import { API_ROUTES } from "../../constants/API_ROUTES";

export const bannerService = {
  get_banner: async (token, params = {}) =>
    https.get(API_ROUTES.BANNER.GET_BANNER, {
      headers: { Authorization: `Bearer ${token}` },
      params,
    }),

  get_detail: (token, banner_id) =>
    https.get(`${API_ROUTES.BANNER.GET_BY_ID}/${banner_id}`, {
      headers: { Authorization: `Bearer ${token}` },
    }),

  update: (token, banner_id, formData) =>
    https.put(`${API_ROUTES.BANNER.UPDATE}/${banner_id}`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    }),

  create: (token, formData) =>
    https.post(API_ROUTES.BANNER.CREATE, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    }),

  applyMobile: (token, { newIds, enable }) =>
    https.put(
      API_ROUTES.BANNER.APPLY,
      { newIds, enable },
      { headers: { Authorization: `Bearer ${token}` } }
    ),

  delete: (token, banner_id) =>
    https.delete(`${API_ROUTES.BANNER.DELETE}/${banner_id}`, {
      headers: { Authorization: `Bearer ${token}` },
    }),
};
